import * as Yup from 'yup'

const RoleSchema = Yup.object().shape({
  name: Yup.string()
    .required('Role name is required.'),
})

export default RoleSchema
